import type { LDContext } from 'launchdarkly-react-client-sdk'

import { env } from '@/shared/env'

import type { LaunchdarklyContextData } from './types'

export const isLaunchdarklyEnabled = () =>
  Boolean(env.VITE_LAUNCHDARKLY_CLIENT_ID)

export const getContext = ({
  linkId,
  companyDocument,
  mainSeller,
}: LaunchdarklyContextData = {}): LDContext => {
  if (!linkId) {
    return { kind: 'user', anonymous: true }
  }

  const document = companyDocument?.replace(/\D/g, '')

  return {
    kind: 'multi',
    paymentLink: {
      key: linkId,
      ...(typeof mainSeller === 'number' ? { mainSeller } : {}),
    },
    ...(document
      ? {
          company: {
            key: document,
            document,
          },
        }
      : {}),
  }
}
